import { Box } from '@mui/joy';

// Shared row chrome for the events settings list: same padding, background,
// and hover treatment whether the row is being viewed or edited.
export function EventRowShell({ children }) {
  return (
    <Box
      sx={{
        py: 0.75,
        px: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'background.level1',
        borderRadius: 'sm',
        '&:hover': { bgcolor: 'background.level2' },
      }}
    >
      {children}
    </Box>
  );
}
